export const STAGES = [
    { key: "new", label: "New Leads", color: "bg-kanban-new" },
    { key: "research_in_progress", label: "Research In Progress", color: "bg-brand" },
    { key: "sent_to_crm", label: "Sent to CRM", color: "bg-kanban-won" },
    { key: "dropped", label: "Dropped", color: "bg-zinc-300" },
];
